import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Stack,
} from '@mui/material';
import useI18n, { Ti18nId } from 'hooks/useI18n';

interface Props extends RadioGroupProps {
  i18nKey?: string;
  i18nNullKey?: string;
  value?: number;
  values: number[];
  defaultValue: number;
  width?: string;
  disabled?: boolean;
  direction?: string;
  whiteSpace?: string;
  /** 라디오 항목 간격 축소 (성별 3옵션 등) */
  compact?: boolean;
  onChange?: (value: any) => void;
}

const MuiRadioGroup = ({
  i18nKey,
  i18nNullKey,
  values,
  defaultValue,
  disabled,
  width,
  whiteSpace,
  direction,
  compact,
  onChange,
  ...props
}: Props) => {
  const i18n = useI18n();
  const label = (value: number) => {
    if (!value && i18nNullKey) return i18n(i18nNullKey as Ti18nId);
    if (i18nKey) return i18n(`${i18nKey}.${value}` as Ti18nId);
    return '';
  };

  const getLabelSx = (value: number) => {
    if (compact) return { width: width ?? 'auto', mr: 0.5, ml: 0 };
    if (value === 0) return { width: '80px' };
    return { width: `${width ? width : '100px'}` };
  };

  return (
    <RadioGroup
      row
      defaultValue={defaultValue}
      sx={{
        flexWrap: 'nowrap',
        whiteSpace: 'pre',
        display: 'inline-flex',
        // compact 는 칸이 모자라면 다음 줄로 내린다
        ...(compact && { maxWidth: '100%' }),
      }}
      onChange={(_, value) => onChange && onChange(value)}
      {...props}
    >
      <Stack
        direction={direction === 'column' ? 'column' : 'row'}
        spacing={compact || direction === 'column' ? 0 : 1}
        sx={compact ? { flexWrap: 'wrap', minWidth: 0 } : undefined}
      >
        {values.map(value => (
          <FormControlLabel
            key={value}
            value={value}
            disabled={disabled}
            control={
              <Radio
                size="small"
                sx={{
                  '&.Mui-checked': {
                    color: '#2D73DC',
                  },
                }}
              />
            }
            label={label(value)}
            sx={getLabelSx(value)}
          />
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default MuiRadioGroup;
